export default __webpack_public_path__ + "static/media/staking-blue.fc6f9a34.mp4";